import { AppState } from 'app/store';

export const getAudioPlayer = (appState: AppState) => appState.audioPlayer;

export const getPlayerCurrentAudio = (appState: AppState) =>
  appState.audioPlayer.queue[appState.audioPlayer.queueIndex];

export const getIsPlayerLoading = (appState: AppState) =>
  appState.audioPlayer.queue[appState.audioPlayer.queueIndex]?.loading ||
  !appState.audioPlayer.isPlayerReady;

export const getPlayAudioLink = (appState: AppState) =>
  appState.auth.services?.songs?._links.playAudio;

export const getPlayerMode = (appState: AppState) =>
  appState.audioPlayer.playMode;

export const getPlaylistLoadingState = (appState: AppState) =>
  appState.audioPlayer.playlistLoadingState;

export const getPlaylistDetails = (appState: AppState) =>
  appState.audioPlayer.playlistDetails;

export const isPlayerOpen = (appState: AppState) => appState.audioPlayer.isOpen;

export const getPlayerHeight = (appState: AppState) => {
  const { isOpen } = appState.audioPlayer;
  return isOpen ? 64 : 0;
};

export const isExtendedPlayer = (appState: AppState) =>
  appState.audioPlayer.extended;

export const shouldRepeat = (appState: AppState) => appState.audioPlayer.repeat;
